import { IApplicationState } from '../types/redux';

/**
 * Селектор, который возвращает true если все данные о графиках null.
 * Такое может произойти на nodejs если апи графиков упали.
 * Показываем пользователю экран ошибки в этом кейсе.
 */
export function getIsCrashError(state: IApplicationState) {
  const { prices, demand, supply, mortgage } = state.charts;

  return !prices && !demand && !supply && !mortgage;
}
